import { cva } from '@/styled-system/css';

export const legendRecipe = cva({
  base: {
    color: 'text.neutral',
    cursor: 'default',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    requiredText: {
      asterisk: {
        _after: {
          content: '"*" / ""',
          color: 'Legend.indicator.required',
          marginInlineStart: 'micro.default',
        },
      },
      label: {
        _after: {
          content: '"(required)"',
          color: 'text.subtle',
          fontWeight: '{normal}',
          marginInlineStart: 'micro.default',
        },
      },
    },
    optional: {
      true: {
        _after: {
          content: '"(optional)"',
          color: 'text.subtle',
          fontWeight: '{normal}',
          marginInlineStart: 'micro.default',
        },
      },
      false: {},
    },
    size: {
      md: {
        textStyle: 'body-sm-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
  },
});
